// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMutation } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { useStore } from "react-redux";
import { escapeTranslationValues, } from "@sequentech/ui-core";
import { CAST_BALLOT } from "../queries/CastBallot";
import { provideBallotService } from "../services/BallotService";
import { castVoteErrorMessage } from "../services/CastVoteErrors";
import { CastBallotsErrorType } from "../services/VotingPortalError";
import { addCastVotes } from "../store/castVotes/castVotesSlice";
import { useAppDispatch } from "../store/hooks";
import { clearAuditableBallot } from "../store/auditableBallots/auditableBallotsSlice";
import { setConfirmationScreenData } from "../store/castVotes/confirmationScreenDataSlice";
// Signs "cast this Ballot ID" with the key that signed the ballot at review.
// Throws when the page no longer holds that key.
export var signReceivedCast = function (receivedBallot, ballotBoxKey) { return ({
    receivedBallot: receivedBallot,
    ballotBoxKey: ballotBoxKey,
    castSignature: provideBallotService().signBallotCast(receivedBallot.election_id, receivedBallot.voter_signing_pk, receivedBallot.ballot_id),
}); };
/**
 * Casts a received ballot. The cast counts as done only once this device has
 * checked the ballot box's signature over the cast receipt.
 */
export var useCastReceivedBallot = function () {
    var t = useTranslation().t;
    var dispatch = useAppDispatch();
    var store = useStore();
    var castBallot = useMutation(CAST_BALLOT)[0];
    var _a = provideBallotService(), verifyCastReceipt = _a.verifyCastReceipt, forgetVoterSigningKey = _a.forgetVoterSigningKey;
    return function (_a, reportError_1) {
        var args_1 = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args_1[_i - 2] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([_a, reportError_1], args_1, true), Promise, function (_b, reportError, isCurrent) {
            var setErrorMsg, answer, result, cast, error_1, castReceipt, currentBallot;
            var _c, _d, _e;
            var receivedBallot = _b.receivedBallot, ballotBoxKey = _b.ballotBoxKey, castSignature = _b.castSignature;
            if (isCurrent === void 0) { isCurrent = function () { return true; }; }
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        setErrorMsg = function (message) {
                            if (isCurrent())
                                reportError(message);
                        };
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, castBallot({
                                variables: {
                                    electionId: receivedBallot.election_id,
                                    ballotId: receivedBallot.ballot_id,
                                    castSignature: castSignature,
                                },
                            })];
                    case 2:
                        result = _f.sent();
                        cast = (_c = result.data) === null || _c === void 0 ? void 0 : _c.cast_ballot;
                        if (result.error || !cast) {
                            console.log((_d = result.error) === null || _d === void 0 ? void 0 : _d.message);
                            setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.UNABLE_TO_FETCH_DATA)));
                            return [2 /*return*/, false];
                        }
                        answer = cast;
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _f.sent();
                        console.log(error_1);
                        setErrorMsg(castVoteErrorMessage(error_1, t));
                        return [2 /*return*/, false];
                    case 4:
                        castReceipt = {
                            election_event_id: receivedBallot.election_event_id,
                            election_id: receivedBallot.election_id,
                            ballot_id: receivedBallot.ballot_id,
                            received_at: receivedBallot.received_at,
                            cast_at: answer.cast_at,
                            key_id: answer.key_id,
                            cast_signature: castSignature,
                            cast_receipt_signature: answer.cast_receipt_signature,
                        };
                        try {
                            verifyCastReceipt(ballotBoxKey, castReceipt);
                        }
                        catch (error) {
                            console.error("The ballot box's cast receipt does not verify:", error);
                            setErrorMsg(t("reviewScreen.error.".concat(CastBallotsErrorType.INCONSISTENT_HASH), escapeTranslationValues({
                                ballotId: receivedBallot.ballot_id,
                                auditableBallotHash: receivedBallot.ballot_hash,
                            })));
                            return [2 /*return*/, false];
                        }
                        if (!isCurrent())
                            return [2 /*return*/, false];
                        currentBallot = (_e = store.getState().auditableBallots[receivedBallot.election_id]) === null || _e === void 0 ? void 0 : _e.auditableBallot;
                        if (!currentBallot || currentBallot.ballot_hash === receivedBallot.ballot_hash) {
                            forgetVoterSigningKey(receivedBallot.election_id);
                            dispatch(clearAuditableBallot(receivedBallot.election_id));
                        }
                        dispatch(setConfirmationScreenData({
                            electionId: receivedBallot.election_id,
                            confirmationScreenData: { ballotId: receivedBallot.ballot_id, isDemo: false },
                        }));
                        dispatch(addCastVotes([
                            {
                                id: answer.cast_vote_id,
                                tenant_id: receivedBallot.tenant_id,
                                election_id: receivedBallot.election_id,
                                election_event_id: receivedBallot.election_event_id,
                                created_at: answer.cast_at,
                            },
                        ]));
                        return [2 /*return*/, true];
                }
            });
        });
    };
};
